import "core-js/modules/es.array.slice.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "message-list box"
  }, [_vm.status == 0 ? _c("el-alert", {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      title: "当前咨询暂时无人认领，回复后您将自动成为跟进人",
      type: "warning",
      center: "",
      closable: false,
      "show-icon": ""
    }
  }) : _vm._e(), _vm.status == 3 ? _c("el-alert", {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      title: _vm.closeTitle,
      type: "info",
      center: "",
      closable: false,
      "show-icon": ""
    }
  }) : _vm._e(), _vm._l(_vm.tableData, function (item, index) {
    var _item$createAt, _item$imgs;
    return _c("div", {
      key: index,
      staticClass: "message-item"
    }, [_c("div", {
      staticClass: "message-header wlc-f-c"
    }, [_c("div", {
      staticClass: "user-info wlc-f-c"
    }, [_c("span", {
      staticClass: "name",
      class: item.role === "user" && "user-name"
    }, [_vm._v(_vm._s(item.followName))])]), _c("span", {
      staticClass: "time"
    }, [_vm._v(_vm._s((item === null || item === void 0 || (_item$createAt = item.createAt) === null || _item$createAt === void 0 ? void 0 : _item$createAt.slice(0, -3)) || ""))])]), _c("div", {
      staticClass: "message-content"
    }, [item.content ? _c("p", [_vm._v(_vm._s(item.content))]) : _vm._e(), (_item$imgs = item.imgs) !== null && _item$imgs !== void 0 && _item$imgs.length || item.video ? _c("div", {
      staticClass: "media-list"
    }, [item.video ? _c("div", {
      staticClass: "video-list wlc-f-c"
    }, [_c("div", {
      staticClass: "video-box wlc-pointer",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.previewVideo(item.video);
        }
      }
    }, [_c("video", {
      staticClass: "message-video",
      attrs: {
        src: item.video
      }
    }), _c("i", {
      staticClass: "play-icon el-icon-caret-right"
    })])]) : _vm._e(), _c("div", {
      staticClass: "img-list wlc-f-c"
    }, _vm._l(item.imgs, function (img, imgIndex) {
      return _c("div", {
        key: imgIndex,
        staticClass: "message-box"
      }, [_c("wlc-image", {
        ref: "image_".concat(index),
        refInFor: true,
        attrs: {
          src: img,
          current: imgIndex,
          list: item.imgs,
          width: "76",
          compression: true
        }
      }), _c("div", {
        staticClass: "icon-group wlc-f-c",
        on: {
          click: function click($event) {
            $event.stopPropagation();
            return _vm.previewImage(index, imgIndex, item.imgs);
          }
        }
      }, [_c("i", {
        staticClass: "fa fa-eye"
      })])], 1);
    }), 0)]) : _vm._e()]), index < _vm.list.length - 1 ? _c("div", {
      staticClass: "line"
    }) : _vm._e()]);
  }), _c("div", {
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_c("el-pagination", {
    attrs: {
      "page-sizes": [5, 10, 20, 50],
      "page-size": _vm.pagination.pageSize,
      "current-page": _vm.pagination.pageNum,
      layout: "total, sizes, prev, pager, next",
      total: _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _c("video-preview", {
    ref: "videoPreview",
    attrs: {
      url: _vm.previewVideoUrl
    }
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };